import {
  EcommerceProductsAction,
  LOAD_ECOMMERCE_PRODUCTS,
  LOAD_ECOMMERCE_PRODUCTS_FAIL,
  LOAD_ECOMMERCE_PRODUCTS_SUCCESS,
  LoadEcommerceProductsFails,
  LoadEcommerceProductsSuccess
} from "../actions";
import {IEcommerceProduct} from "../../websites/website/ecommerce/ecommerce-product.interface";

export interface IEcommerceEntityState {
  products: IEcommerceProduct[];
  productsCount: number;
  orders: IEcommerceProduct[];
  ordersCount: number;
  loading: boolean;
  loaded: boolean;
}

export interface IEcommerceState {
  entities: { [websiteId: number]: IEcommerceEntityState };
  loading: boolean;
  loaded: boolean;
}

export const initialState: IEcommerceState = {
  entities: {},
  loading: false,
  loaded: false
};

export function reducer(state: IEcommerceState = initialState, action: EcommerceProductsAction): IEcommerceState {
  let payload: any;

  switch (action.type) {

    case  LOAD_ECOMMERCE_PRODUCTS:
      payload = (<LoadEcommerceProductsSuccess>action).payload;
      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state[payload.websiteId],
            loading: true,
            loaded: false
          }
        }
      };

    case LOAD_ECOMMERCE_PRODUCTS_SUCCESS:
      payload = (<LoadEcommerceProductsSuccess>action).payload;
      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state.entities[payload.websiteId],
            products: payload.entities,
            productsCount: payload.productsCount,
            loading: false,
            loaded: true
          }
        }
      };

    case  LOAD_ECOMMERCE_PRODUCTS_FAIL:
      payload = (<LoadEcommerceProductsFails>action).payload;
      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state.entities[payload.websiteId],
            loading: false,
            loaded: true
          }
        }
      };

  }

  return state;
}
